import axios from 'axios';

export const ezipay = async (payload) => {
  try {
    return await axios.post('ezipay', payload);
  } catch (error) {
    return error;
  }
};
